<div class="error-message"><ng-content></ng-content></div>
